/**
 * ./exercise6/Exercise6.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate instead of useHistory
import "../exercise2/Exercise2.css";
import Curtain from "../components/Curtain"; // Import the reusable Curtain component
import Icon from "./icons/exercise6icon.svg"; // Import the person icon

const Exercise6 = () => {
  const [isCurtainActive, setIsCurtainActive] = useState(true);
  const navigate = useNavigate(); // Create a navigate function for navigation

  useEffect(() => {
    // After the curtain disappears, we set isCurtainActive to false
    const timer = setTimeout(() => {
      setIsCurtainActive(false);
    }, 2000); // Match the duration of the curtain disappearance

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  const handlePersonClick = () => {
    navigate("/Warmupwelcome", { state: { exerciseNumber: 6} });
  };

  return (
    <div className="exercise2-page">
      {/* Display the curtain and set it to "disappear" */}
      {isCurtainActive && <Curtain disappear={true} duration={2000} />}

      {/* Text content */}
      <div className="exercise2-header">
        <h1>Exercise 6: Peripheral Vision Training</h1>
      </div>

      {/* Blue bottom area */}
      <div className="exercise2-bottom">
        <img
          className="exercise2-icon"
          src={Icon}
          alt="Icon"
          onClick={handlePersonClick} // Add onClick event to handle navigation
        />
        <button
          className="start-exercise"
          onClick={() => {
            navigate("/exercise6intro");
          }}
        >
          <b>START</b>
        </button>
      </div>
    </div>
  );
};

export default Exercise6;
